module.exports = __webpack_public_path__ + "img/edit.cefaff1f.svg";